import {OverlayState} from "@/hooks/common/useOverlay";
import {hrefSSO} from "@COMPONENTS/common/commonUtil";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {TextButton} from "@FRAMEWORK/ui/mobile/button";
import {Flex} from "@FRAMEWORK/ui/mobile/layout";
import {PopupContainer} from "@FRAMEWORK/ui/mobile/popup";
import useEventDetail from "@QUERIES/prdt/event/useEventDetail";

interface InquiryPopupProps extends OverlayState {
	evCd: string;
}

const InquiryPopup = (props: InquiryPopupProps) => {
	const {evCd, ...overlayProps} = props;
	/** 행사 정보 */
	const event = useEventDetail(evCd).data.body;

	const telNo = event.mgmUserInfo === "Y" ? event.phoneDirect : event.mgmUserTelNo ?? event.phoneDirect;
	const inquiry = () => {
		const path = `${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/qnaWrite.yb?evCd=${evCd}`;
		hrefSSO(path);
	};
	return (
		<PopupContainer {...overlayProps} size="basic" title="문의하기">
			<Flex direction="column" gap="10">
				<TextButton size="default" types="base" text="1:1 문의" onClick={inquiry} />
				<TextButton
					size="default"
					types="base"
					text="전화 문의"
					onClick={() => {
						location.href = `tel:${telNo}`;
					}}
				/>
			</Flex>
		</PopupContainer>
	);
};

export default InquiryPopup;
